export const CAREGIVER_HIDE_NAVBAR_PREFIXES = ["/caregiver", "/caregiver/messenger"];

export const CAREGIVER_TOP_NAV_ITEMS = [
  { to: "/caregiver", label: "Caregivers", end: true, icon: "grid" },
  { to: "/caregiver/start-end-service", label: "Start / End Service", icon: "clock" },
  { to: "/caregiver/my-bookings", label: "My Bookings", icon: "list" },
  { to: "/caregiver/earnings", label: "Earnings", icon: "wallet" },
  { to: "/caregiver/complete-profile", label: "Profile", icon: "user" },
];

export const CAREGIVER_SIDEBAR_ITEMS = [
  { to: "/caregiver", label: "Dashboard", end: true, icon: "grid" },
  { to: "/caregiver/start-end-service", label: "Start / End Service", icon: "clock" },
  { to: "/caregiver/my-bookings", label: "My Bookings", icon: "list" },
  { to: "/caregiver/subscription", label: "Subscription & Credits", icon: "card" },
  { to: "/caregiver/payments", label: "Payments", icon: "rupee" },
  { to: "/caregiver/my-schedule", label: "My Schedule", icon: "calendar" },
  { to: "/caregiver/availability", label: "Availability Calendar", icon: "calendar" },
  { to: "/caregiver/care-notes", label: "Care Notes", icon: "document" },
  { to: "/caregiver/earnings", label: "Earnings", icon: "wallet" },
  { to: "/caregiver/complete-profile", label: "Profile", icon: "user" },
  { to: "/caregiver/pricing", label: "Pricing & Packages", icon: "rupee" },
  { to: "/caregiver/support", label: "Help & Support", icon: "help" },
];

export { PHYSIO_SIDEBAR_ITEMS, PHYSIO_TOP_NAV_ITEMS } from "../../config/physioCareHubConfig";
export { NURSE_SIDEBAR_ITEMS } from "../../config/nurseCareHubConfig";

export const CAREGIVER_USER_META = {
  initials: "",
  name: "",
  role: "Care Attendant",
};
